import React from "react";
import "./Receiver_info_holder.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faI, faL, faLocationDot, faPhone } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import Cancel_Order_btn from "../../../../../common/common_btn/cancel_Order_btn/Cancel_Order_btn";
import { faIdBadge } from "@fortawesome/free-regular-svg-icons";
import { encodeId } from "../../../../../../utils/common";



function Receiver_info_holder({ showCancelBtn, User, showReturedBtn, Address, id, TrakingID = null, deliveryStatus = true }) {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate(`/cancel-order/${encodeId(id)}`);
    };
    const handleReturnClick = () => {
        navigate(`/return-order/${encodeId(id)}`);
    };

    const formattedAddress = [
        Address?.building,
        Address?.floor,
        Address?.apartment,
        Address?.street,
        Address?.direction,
        Address?.Users_Address_Detail?.City?.name,
        Address?.Users_Address_Detail?.State?.name,
        Address?.Users_Address_Detail?.Country?.name,
        Address?.Users_Address_Detail?.Pincode?.name,
        Address?.Users_Address_Detail?.Area?.name,
    ].filter(Boolean).join(", ");
    return (
        <>
            <section className="Receiver_info_holder">
                <div className="text_holder">
                    <h4>{User?.name || ""}</h4>
                    <div className="name_holder">
                        <div>
                            <div className="icon_holder">
                                <FontAwesomeIcon className="info_icon" icon={faPhone} />
                            </div>
                        </div>
                        <p> {User?.contact_no || ""}</p>
                    </div>

                    <p>{Address?.Address_Type?.name || " "}</p>
                    <div className="name_holder">
                        <div>
                            <div className="icon_holder">
                                <FontAwesomeIcon className="info_icon" icon={faLocationDot} />
                            </div>
                        </div>
                        <p>{formattedAddress ? formattedAddress : "No Address Found"}</p>
                    </div>

                    {TrakingID && <div className="name_holder">
                        <div>
                            <div className="icon_holder">
                                <FontAwesomeIcon className="info_icon" icon={faIdBadge} />
                            </div>
                        </div>
                        <p>Tracking ID : {TrakingID}</p>
                    </div>
                    }
                    {(showCancelBtn && deliveryStatus) && (
                        <Cancel_Order_btn btnText={"Cancel Order"} onClick={handleClick} />
                    )}
                    {showReturedBtn && (
                        <Cancel_Order_btn btnText={"Return Order"} onClick={handleReturnClick} />
                    )}

                </div>
            </section >
        </>
    );
}

export default Receiver_info_holder;
